var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlinemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 1.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 4.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 1.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 4.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinemove);
export default __webpack_public_path__ + "static/media/vuesaxoutlinemove.0f7992c6abd85df8b2f88388ebe11f9a.svg";
export { ForwardRef as ReactComponent };